import { sanitizeHtml } from '../../utils/sanitize';

const AIEmailView = ({ email }) => {
  return (
    <div className="flex h-full max-h-screen w-full overflow-y-auto p-2 sm:p-4">
      <div className="mx-auto max-h-[90vh] w-full overflow-y-auto rounded-lg bg-white p-4 shadow-md sm:p-6">
        {/* Header */}
        <div className="mb-4 flex items-center">
          <h2 className="text-lg font-semibold text-gray-900">Summary</h2>
        </div>

        {/* Summary */}
        <p className="mb-4 w-full flex-wrap text-sm font-medium text-gray-700 sm:w-4/5">
          {email?.summary}
        </p>

        {/* Critical Points */}
        {email?.criticalPoints?.length > 0 && (
          <>
            <h3 className="mb-2 font-semibold text-gray-900">
              Critical Points
            </h3>
            <ul className="mb-4 list-inside list-disc text-sm text-gray-700">
              {email.criticalPoints.map((point, index) => {
                const formattedText = point.replace(
                  /\*(.*?)\*/g,
                  '<strong>$1</strong>',
                );
                return (
                  <p
                    key={index}
                    className="mb-1 w-fit rounded bg-gray-200 px-3 py-1 text-sm hover:bg-gray-300"
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(formattedText),
                    }}
                  />
                );
              })}
            </ul>
          </>
        )}

        {/* Action Items */}
        {email?.actionItems?.length > 0 && (
          <>
            <h3 className="mb-2 font-semibold text-gray-900">Actions</h3>
            <div className="flex flex-col gap-2">
              {email.actionItems.map((action, index) => (
                <div key={index}>
                  <button className="mb-1 w-fit rounded bg-gray-200 px-3 py-1 text-sm text-gray-700 hover:bg-gray-300">
                    {action?.task}
                  </button>
                  {/* Uncomment to show applications
              {action.applications?.map((application, i) => (
                <button key={i} className="px-3 mb-1 ml-2 py-1 w-fit text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200">
                  {application}
                </button>
              ))} */}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AIEmailView;
